export default __webpack_public_path__ + "static/media/izqv2.f9c18f04.png";